import get from 'lodash/get';

const keyGetterGenerator = (...keyProps) => (
  (element) => {
    if (element) {
      if (element.props) {
        return JSON.stringify(keyProps.map(keyProp => get(element.props, keyProp)));
      }

      return get(element, 'key');
    }

    return undefined;
  }
);

export default keyGetterGenerator;
